import { FormFieldsBoxMui as FormFieldsBox } from '@spotify/confidence-core-react';
import { MetricsV1MetricAverageMetricSpec as AverageSpec } from '@spotify/confidence-graphql';

import { AggregatedMeasurement } from './AggregatedMeasurement';

type AggregationFormProps = {
  value: AverageSpec;
  entity?: string;
  factTable: string;
  onChange: (newSpec: AverageSpec) => void;
};

export const AggregationForm = ({
  value,
  entity = '',
  factTable,
  onChange,
}: AggregationFormProps) => (
  <FormFieldsBox>
    <AggregatedMeasurement.Root
      measurement={value.measurement}
      aggregation={value.aggregation}
      entity={entity}
      factTable={factTable}
      onChange={(measurement, aggregation) => {
        onChange({
          ...value,
          measurement: measurement ? { name: measurement.name } : undefined,
          aggregation: { ...value.aggregation, ...aggregation },
        });
      }}
     data-track-source-anchor="4bd59f3ad7;aggregation-form-root">
      <AggregatedMeasurement.Select
        label="Measurement"
        helperText="This measurement is the basis for your metric."
       data-track-source-anchor="d7777249b4"/>
      <AggregatedMeasurement.Type />
      <AggregatedMeasurement.Threshold />
      <AggregatedMeasurement.Cap idPrefix="aggregation" />
    </AggregatedMeasurement.Root>
  </FormFieldsBox>
);
